<template>
  <div>
    <div ref="cardElement" class="stripe-wrapper"></div>
  </div>
</template>

<style lang="less">
.stripe-wrapper {
  padding: 15px;
  background: white;
  border: 1px solid #ccc;
  border-radius: 3px;
  display: block;
  margin-top: 30px;
}
</style>

<script>
import axios from "axios";
export default {
  data: function() {
    return {
      stripe: null,
      cardElement: null,
    };
  },
  props: [
    "options",
    "existingSubscriptionId",
    "invoice",
    "address",
    "before3DSRedirect",
  ],
  mounted: function() {
    this.stripe = Stripe(this.options.stripe_key, {
      betas: ["payment_intent_beta_3"],
    });
    let elements = this.stripe.elements();
    this.cardElement = elements.create("card");
    this.cardElement.mount(this.$refs.cardElement);
  },
  methods: {
    async getSource() {
      let stripeResponse, customer;
      stripeResponse = await this.stripe.createSource(this.cardElement, {
        owner: {
          name: this.options.customer.name,
          email: this.options.customer.email,
        },
      });
      if (stripeResponse.error) {
        this.$emit("payment-error", stripeResponse.error.message);
        return;
      }
      let cardSource = stripeResponse.source;
      try {
        let data = {
          source_id: cardSource.id,
          client_secret: cardSource.client_secret,
          address: this.address,
        };
        if (this.existingSubscriptionId) {
          data.subscription_id = this.existingSubscriptionId;
        }
        customer = await axios.post("/payment/create_customer", data);
      } catch (e) {
        let message =
          e.response && e.response.data.error
            ? e.response.data.error.description
            : "Unable to add payment card.";
        this.$emit("payment-error", message);
        return;
      }
      if (cardSource.card.three_d_secure === "required") {
        // need to replace the customer source with a 3ds supporting version
        let return_url = window.location.origin + this.$route.path;
        if (this.existingSubscriptionId) {
          return_url = `${
            window.location.origin
          }/settings/billing?subscription=${this.existingSubscriptionId}`;
          if (this.invoice) {
            return_url += `&invoice=${this.invoice.id}`;
          } else {
            return_url += `&restart&unit_cost=${this.options.unit_cost}&seats=${this.options.seats}&pricing_period=${this.options.pricing_period}&plan_id=${this.options.plan_id}`;
          }
        }
        stripeResponse = await this.stripe.createSource({
          type: "three_d_secure",
          amount: this.options.amount,
          currency: "usd",
          three_d_secure: {
            customer: customer.id,
            card: cardSource.id,
          },
          redirect: {
            return_url,
          },
        });
        if (stripeResponse.error) {
          this.$emit("payment-error", stripeResponse.error.message);
          return;
        }

        if (this.before3DSRedirect) {
          await this.before3DSRedirect();
        }

        let threeDeeSource = stripeResponse.source;
        window.location = threeDeeSource.redirect.url;
        return;
      } else {
        this.$emit("got-source", cardSource);
      }
    },
    pay() {
      this.getSource();
    },
  },
};
</script>
